import { useState, useEffect } from 'react';
import { Box, Stack, Typography, Avatar, Divider, Grid, CardMedia, Button, Link, TextField } from '@mui/material';
import { List, ListItem, ListItemText, ListItemButton } from '@mui/material';
import { ToggleButtonGroup, ToggleButton, ImageList, ImageListItem } from '@mui/material';

import { pb } from '../utilities/pocketbase';
import { toTitleCase } from '../utilities/common';

export default function FinalistDetails() {
    const [finalists, setFinalists] = useState([])
    const [finalistProfile, setFinalistProfile] = useState()
    const [attempts, setAttempts] = useState([])
    const [sortedAttempts, setSortedAttempts] = useState({})
    const [outoffocuses, setOutoffocuses] = useState({})
    const [selectedFinalistIndex, setSelectedFinalistIndex] = useState("")
    const [snaps, setSnaps] = useState([])
    const [search, setSearch] = useState("")

    useEffect(() => {
        if (pb?.authStore?.model?.id) {
            pb.collection('readonly_finalists').getFullList({ expand: "finalist_profile,finalist_profile.examinee,finalist_profile.examinee.profile" }).then(response => {
                const temp = {}
                for (const item of response) {
                    temp[item?.expand?.finalist_profile?.expand?.examinee?.username] = item
                }
                setFinalists(temp)
            }).catch(err => {
                console.log("finalist view err: ", err)
            })
        }
    }, [])

    useEffect(() => {
        setFinalistProfile({})
        setAttempts([])
        setSortedAttempts({})
        setOutoffocuses({})
        setSnaps([])

        if (selectedFinalistIndex && Object.keys(finalists).length > 0 && finalists?.[selectedFinalistIndex]?.id) {
            setFinalistProfile(finalists?.[selectedFinalistIndex]?.expand?.finalist_profile)
            pb.collection('readonly_finalist_attempts').getList(1, 50, {
                filter: `finalist.id = '${finalists?.[selectedFinalistIndex]?.id}'`,
            }).then(attempts_ => {
                // console.log("attempts:", attempts_)
                setAttempts(attempts_)
            }).catch(err => {
                console.log("finalist attempts view err: ", err)
            })
            pb.collection('finalist_camera_captures').getFullList({
                sort: '-created',
                filter: `finalist.id = '${finalists?.[selectedFinalistIndex]?.id}'`,
            }).then(pics => {
                setSnaps(pics)
                // console.log("pics: ", pics)
            }).catch(err => {
                console.log("finalist pic view err: ", err)
            })
            pb.collection('finalist_outoffocus_counts').getFirstListItem(`finalist.id = '${finalists?.[selectedFinalistIndex]?.id}'`).then(count => {
                setOutoffocuses(count)
                // console.log("count: ", count)
            }).catch(err => {
                console.log("finalist count view err: ", err)
            })
        }
    }, [selectedFinalistIndex, finalists])

    useEffect(() => {
        if (attempts?.items && attempts?.items.length > 0) {
            let tempAttempts = {}
            const sortedA = attempts?.items.filter(x => x?.questionnumber && x).sort((a, b) => a.questionnumber - b.questionnumber)
            for (const attempt of sortedA) {
                tempAttempts[attempt?.questionnumber] = attempt
            }
            setSortedAttempts(sortedA)
        }
    }, [attempts])

    useEffect(() => {
        if (sortedAttempts) {
            // console.log("sortedAttempts: ", sortedAttempts)
        }
    }, [sortedAttempts])

    return (
        <Grid container gap={1} justifyContent={"center"} alignItems={"flex-start"} sx={{ p: 2 }}>
            <Grid item xs={12} sm={12} md={3} lg={3} sx={{ borderRadius: 3, border: 1, borderColor: "divider" }}>
                <ListItem divider>
                    <ListItemText primary={"Finalists"} secondary={`Total ${Object.keys(finalists).length}`} />
                </ListItem>
                <ListItem divider>
                    <TextField value={search} placeholder='search...' size='small' onChange={(e) => setSearch(e.target.value)} fullWidth />
                </ListItem>
                <Stack maxHeight={window.innerHeight - 232} minHeight={window.innerHeight - 232} sx={{ overflow: "auto", }}>
                    <List>
                        {Object.keys(finalists) && Object.keys(finalists).length > 0 && Object.keys(finalists)
                            .filter(key => key.toLowerCase().includes(search.toLowerCase()) && key)
                            .map(key => finalists[key])
                            .map(finalist => (
                                <ListItemButton divider selected={finalist?.expand?.finalist_profile?.expand?.examinee?.username === selectedFinalistIndex} key={finalist.id} onClick={() => setSelectedFinalistIndex(finalist?.expand?.finalist_profile?.expand?.examinee?.username)}>
                                    <ListItemText primary={"Examinee: " + finalist?.expand?.finalist_profile?.expand?.examinee?.username} secondary={`Profile id: ${finalist?.expand?.finalist_profile?.expand?.examinee?.profile}`} />
                                </ListItemButton>
                            ))}
                    </List>
                </Stack>
            </Grid>
            <Grid item xs={12} sm={12} md={8} lg={8} maxHeight={window.innerHeight - 100} minHeight={window.innerHeight - 100} sx={{ overflow: "auto", borderRadius: 3, border: 1, borderColor: "divider", p: 2 }}>
                {!selectedFinalistIndex && <Typography align='center' variant='subtitle1' sx={{ my: 4 }} fontWeight={"light"}>Select an examinee to see details</Typography>}
                {selectedFinalistIndex && <Stack>
                    {finalistProfile && finalistProfile?.id && <Stack justifyContent={"center"} alignItems={"center"}>
                        <Box sx={{ py: 1 }}>
                            <Avatar sx={{ height: "8rem", width: "8rem" }} alt={finalistProfile?.fullname?.split()[0]} src={`${process.env.REACT_APP_PB_URL}/api/files/${finalistProfile?.collectionId}/${finalistProfile?.id}/${finalistProfile?.display_picture}`} />
                        </Box>
                    </Stack>}
                    <Stack>
                        {finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.username && <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                            <Typography variant='subtitle2' color={"text.secondary"}>Examinee username</Typography>
                            <Typography fontFamily={"JetBrains Mono"} variant='subtitle1'>{finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.username}</Typography>
                        </Stack>}
                        {finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.profile && <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                            <Typography variant='subtitle2' color={"text.secondary"}>Examinee profile</Typography>
                            <Typography fontFamily={"JetBrains Mono"} variant='subtitle1'>{finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.profile}</Typography>
                        </Stack>}
                        <Divider><Typography variant='subtitle2'>Profile</Typography></Divider>
                        {finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.expand?.profile && <Stack>
                            <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                                <Typography variant='subtitle2' color={"text.secondary"}>First name</Typography>
                                <Typography variant='subtitle1'>{finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.expand?.profile?.firstname}</Typography>
                            </Stack>
                            <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                                <Typography variant='subtitle2' color={"text.secondary"}>Last name</Typography>
                                <Typography variant='subtitle1'>{finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.expand?.profile?.lastname}</Typography>
                            </Stack>
                            <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                                <Typography variant='subtitle2' color={"text.secondary"}>Year of Birth</Typography>
                                <Typography variant='subtitle1'>{finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.expand?.profile?.yob}</Typography>
                            </Stack>
                            <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                                <Typography variant='subtitle2' color={"text.secondary"}>Mobile</Typography>
                                <Typography variant='subtitle1'>{finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.expand?.profile?.mobile}</Typography>
                            </Stack>
                            <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                                <Typography variant='subtitle2' color={"text.secondary"}>Email</Typography>
                                <Typography variant='subtitle1'>{finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.expand?.profile?.email}</Typography>
                            </Stack>
                            <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                                <Typography variant='subtitle2' color={"text.secondary"}>Class</Typography>
                                <Typography variant='subtitle1'>{finalists?.[selectedFinalistIndex]?.expand?.finalist_profile?.expand?.examinee?.expand?.profile?.class}</Typography>
                            </Stack>
                        </Stack>}
                        <Divider><Typography variant='subtitle2'>Finalist profile</Typography></Divider>
                        {finalistProfile && finalistProfile?.id && Object.keys(finalistProfile).filter(key => !["expand", "display_picture", "school_id_card", "collectionId", "collectionName", "created", "updated", "id"].includes(key)).map(key => (
                            <Stack key={key} direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                                <Typography variant='subtitle2' color={"text.secondary"}>{toTitleCase(key)}</Typography>
                                <Typography variant='subtitle1'>{finalistProfile?.[key]}</Typography>
                            </Stack>
                        ))}
                    </Stack>
                    <Divider><Typography variant='subtitle2'>ID card</Typography></Divider>
                    {finalistProfile && finalistProfile?.id && <Stack justifyContent={"center"} alignItems={"center"}>
                        <Stack spacing={2} justifyContent={"center"} alignItems={"center"} sx={{ py: 1 }}>
                            <CardMedia sx={{ borderRadius: 3, maxHeight: 500 }} component={"img"} alt={finalistProfile?.fullname?.split()[0]} src={`${process.env.REACT_APP_PB_URL}/api/files/${finalistProfile?.collectionId}/${finalistProfile?.id}/${finalistProfile?.school_id_card}`} />
                            <Button component={Link} target='_blank' download href={`${process.env.REACT_APP_PB_URL}/api/files/${finalistProfile?.collectionId}/${finalistProfile?.id}/${finalistProfile?.school_id_card}`}>Download</Button>
                        </Stack>
                    </Stack>}
                    <Divider sx={{ my: 2 }}><Typography variant='subtitle2'>Out of focuses</Typography></Divider>
                    {outoffocuses?.outoffocuses && <Typography variant='subtitle1' align='right' fontWeight={"bold"} sx={{ mb: 2 }}>
                        Total out of focuses: {outoffocuses?.outoffocuses}
                    </Typography>}
                    <Divider sx={{ my: 2 }}><Typography variant='subtitle2'>Attempts</Typography></Divider>
                    <Stack spacing={1} justifyContent={"center"} minWidth={"sm"}>
                        {Object.keys(sortedAttempts) && sortedAttempts.length > 0 && sortedAttempts.map((attempt, index) => (
                            <Stack key={index} direction={"row"} spacing={1} alignItems={"flex-end"} justifyContent={"flex-start"}>
                                <ToggleButtonGroup
                                    value={attempt?.option}
                                    fullWidth
                                    disabled
                                >
                                    <ToggleButton sx={{ py: 1, fontFamily: "JetBrains Mono", fontWeight: "bold" }} disabled={true} value={attempt?.questionnumber}>
                                        {`${attempt?.questionnumber}`.toString().padStart(3, "0")}.
                                    </ToggleButton>
                                    <ToggleButton sx={{ py: 1 }} value="A" color={"info"}>
                                        <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>A</Typography>
                                    </ToggleButton>
                                    <ToggleButton sx={{ py: 1 }} value="B" color={"info"}>
                                        <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>B</Typography>
                                    </ToggleButton>
                                    <ToggleButton sx={{ py: 1 }} value="C" color={"info"}>
                                        <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>C</Typography>
                                    </ToggleButton>
                                    <ToggleButton sx={{ py: 1 }} value="D" color={"info"}>
                                        <Typography variant="h6" sx={{ fontFamily: "JetBrains Mono", fontWeight: "bold" }}>D</Typography>
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Stack>
                        ))}
                    </Stack>
                    <Divider sx={{ my: 2 }}><Typography variant='subtitle2'>Camera captures</Typography></Divider>
                    <ImageList cols={5}>
                        {snaps.map((item) => (
                            <ImageListItem key={item.id}>
                                <img
                                    style={{ borderRadius: 3 }}
                                    srcSet={`${process.env.REACT_APP_PB_URL}/api/files/${item?.collectionId}/${item?.id}/${item?.camera_capture?.[0]}`}
                                    // src={`${process.env.REACT_APP_PB_URL}/api/files/${item?.collectionId}/${item?.id}/${item?.camera_capture?.[0]}`}
                                    alt={item?.remarks}
                                    loading="lazy"
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                </Stack>}
            </Grid>
        </Grid>
    )
}